<template>
    <a :href="link" :target="target" class="item" :class="{active: active}">{{label}}</a>
</template>

<script>
export default {
    inheritAttrs: false,
    name: 'base-dropdown-item',
    props: {
        label: {
            type: String,
            description: 'Item label',
        },
        link: {
            type: String,
            description: 'Item link',
        },
        target: {
            type: String,
            description: 'HTML <a> target Attribute',
        },
        active: {
            type: Boolean,
            description: 'Active link',
        },
    },
};
</script>

<style scoped lang="scss">
.item {
    font-size: 16px;
    line-height: 20px;
    color: #200033;
    padding: 11px 18px;
    display: block;
    text-decoration: none;
    &:hover {
        background: #F2F2FF;
    }
    &:first-child {
        border-top-right-radius: 12px;
        border-top-left-radius: 12px;
    }
    &:last-child {
        border-bottom-right-radius: 12px;
        border-bottom-left-radius: 12px;
    }
}
</style>

